<template>
  <div v-if="apidata">
    <ul class='text'>
      <li>FANFARE INC.</li>
      <li class='footerLink'>COLOPHON</li>
      <li v-html="about[3]" class='footerText' style='margin-bottom: 9px'></li>
      <li class='footerText'>fanfare inc. concept, design, art direction, management, exhibition and catalogue by <nobr>Freja Kir</nobr>, <nobr>Lotte van de Hoef</nobr> and <nobr>Miquel Hervás Gómez.</nobr></li>
      <li class='footerText'>fanfare tetatet podcast by <nobr>Charlie Clemoes</nobr> and <nobr>Freja Kir.</nobr></li>
      <li class='footerText'>Palermo Manifesta display and breakfast together with <nobr>Nickie Fenja Sigurdsson</nobr>.</li>
      <li class='footerText'>fanfare inc. has been in {{locations.slice(0, -1).join(", ")}} & {{locations.slice(-1).pop()}}.</li>
      <li class='footerText'>fanfare inc. is made possible by the kind support of <nobr>Amsterdam Fonds voor de Kunst</nobr>, <nobr>Danish Art Foundation</nobr> and the <nobr>Creative Industries Fund NL</nobr>.</li>
    </ul>

    <ul class='text marginTop'>
      <li><span class='footerLink'>SPECIAL THANKS TO</span> <nobr>Bram van den Berg</nobr>, <nobr>Femke Dekker</nobr>, <nobr>Eduardo Léon</nobr>, <nobr>Sheona Turnbull</nobr>, <nobr>Florence Parot</nobr>, <nobr>Immo Schneider</nobr>, <nobr>Charlie Clemoes</nobr>, <nobr>Brent Dahl</nobr> and <nobr>Hugo Rocci</nobr>, <nobr>Bonne Suits</nobr>, <nobr>Warrior Shanghai</nobr> and <nobr>The Paper Factory</nobr>
      </li>
    </ul> 

    <ul class='text marginTop'>
      <li class='footerLink'>LINKS</li>
      <li>
        <a class='inline' href='mailto:inc@fanfarefanfare.nl'>Email</a>, 
        <a class='inline noMargin' href='http://fanfarefanfare.nl/' target="_blank">Website</a>
      </li>
      <li>
        <a class='inline noMargin' href='https://www.instagram.com/fanfare_amsterdam/' target="_blank">Instagram</a>, 
      <a class='inline noMargin' href='https://www.facebook.com/fanfarefanfarefanfarefanfarefanfarefanfarefanfare/?' target="_blank">Facebook</a>, 
      <a class='inline noMargin' href='https://soundcloud.com/fanfarefanfarefanfare' target="_blank">Soundcloud</a>, 
      <a class='inline noMargin' href='https://www.twitter.com/fanfare_ams' target="_blank">Twitter</a>
    </li>
      <li><a class='inline noMargin' href='http://eepurl.com/cOYP11' target="_blank">Newsletter</a></li>
    </ul>

    <ul class='text marginTop'>
      <li><span class='footerLink'>WEBSITE </span> <a href='http://bramvandenberg.com' target="_blank">Bram van den Berg</a></li>
      <li class='marginTopBig'><span class='footerLink'>FONT ‘SCARLA REGULAR’</span> <a href='https://www.jung-lee.nl/' target="_blank">Jung-Lee Type Foundry</a></li>
    </ul>
    
  </div>  
</template>

<script>
import _ from 'underscore'

export default {
  name: 'Colophon',
  computed: {
    apidata () {
      return this.$store.state.apidata
    },
    about () {
      return _.values(this.apidata['3-about'])
    },
    locations () {
      const sort = _.sortBy(this.about[5], function(val) {
          return val;
      })
      return sort
    }
  },
  mounted: function () {
    this.$store.state.classBody = 'colophon'
    this.$store.state.compass = false
  },
  beforeRouteLeave (to, from, next) {
    const time = Math.floor(Math.random() * 200) + 10  
    this.$store.state.compass = true 
    setTimeout(function(){ next() }, time)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../styles/global.less";
 
</style>



// WEBPACK FOOTER //
// src/components/Colophon.vue